<template>
  <div class="account-info-page">
    <el-drawer :visible.sync="drawer">
      <el-form :model="drawerForm" ref="drawerForm" :rules="drawerRules" class="edit-form">
        <div class="main-content">
          <el-form-item v-for="(item, index) in drawerLabel" :key="index" :prop="item.prop" :label="item.label + ':'">
            <el-input :type="type == 'password' ? 'password' : 'text'" :placeholder="'请输入' + item.label"
                      v-model="drawerForm[item.prop]"></el-input>
          </el-form-item>
        </div>

        <div class="footer-content">
          <el-form-item>
            <el-button size="mini" @click="onSubmit">确认</el-button>
            <el-button size="mini" @click="onCancel">取消</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-drawer>

    <div class="manage">
      <h3 style="margin-left: 20px; color: green">个人信息管理</h3>

      <div class="manage-header">
        <el-button type="primary" size="mini" @click="modifyPassword()">修改密码</el-button>
        <el-button type="success" size="mini" @click="modifyTel()">修改手机</el-button>
      </div>

      <el-form :model="form" class="manage-form">
        <el-form-item v-for="(item, index) in formLabel" :key="index" :prop="item.prop" :label="item.label + ':'">
          <el-input :disabled="true" v-model="form[item.prop]"></el-input>
        </el-form-item>
        <el-form-item v-if="form.permissions" label="权限列表:" disabled="">
          <el-select v-model="form.selectPermission" multiple placeholder="请选择">
            <el-option v-for="item in form.permissions" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import {accountUpdate, checkPassword, getAccountPermissionSetting} from '@/api/account-api'
import {updateEmployee} from "@/api/organize-api";
import {getAllArea} from "@/api/device-manager-api";

export default {
  mounted() {
    console.log("loginfo =>", this.loginInfo)

    getAllArea().then(({data}) => {
      this.areaTree = data.data
      this.areaTree.forEach((item) => {
        this.areaMap[item.id] = item
        ;(item.areas || []).forEach((area) => {
          this.areaMap[area.id] = area
          area.areas = null
        })
      })
      if (this.$store.state.accountType === "manage" && this.loginInfo.areaId) {
        let area = this.areaMap[this.loginInfo.areaId]
        console.log("area 1 =>", area)
        let form = {...this.form}
        form.areaName = area ? area.name : ""
        this.form = form
      }
    }).catch((error) => {
      console.log("getAllArea error =>", error)
    })

    this.form = {}
    let account
    if (this.$store.state.accountType === "manage") {
      let area = this.areaMap[this.loginInfo.areaId]
      console.log("area 0 =>", area)
      account = this.loginInfo
      this.form.name = this.loginInfo.name
      this.form.telephone = this.loginInfo.telephone
      this.form.createTime = this.getShowTime(this.loginInfo.createTime)
      this.form.updateTime = this.getShowTime(this.loginInfo.updateTime)
      this.form.areaName = area ? area.name : ""
    } else {
      account = this.employeeLoginInfo
      this.form.name = this.employeeLoginInfo.name
      this.form.loginName = this.employeeLoginInfo.loginName
      this.form.telephone = this.employeeLoginInfo.tel
      this.form.createTime = this.getShowTime(this.employeeLoginInfo.registerTime)
      this.formLabel = [
        {prop: 'name', label: '真实姓名'},
        {prop: 'loginName', label: '登录账号'},
        {prop: 'telephone', label: '手机号码'},
        {prop: 'createTime', label: '创建时间'},
        {prop: 'roleName', label: '角色类型'}
      ]
    }
    switch (account.roleType) {
      case "ADMIN":
        this.form.roleName = "超级管理员"
        break
      case "MANAGE":
        this.form.roleName = "系统管理员"
        break
      case "VIEW":
        this.form.roleName = "系统查看员"
        break
      case "GUARD":
        this.form.roleName = "门岗助手"
        break
      case "STAFF":
        this.form.roleName = "员工邀约"
        return false
      case "COMMON":
        this.form.roleName = "自定义角色"
        break
    }


    getAccountPermissionSetting().then(({data}) => {
      if (data.code === 200) {
        this.permissionsAll = data.data
        data.data.forEach((item) => {
          if (item.target === "VISITOR_TOP_DEPARTMENT") {
            this.permissionTree.unshift({
              key: item.target + "|" + item.departmentId,
              type: "top",
              label: item.departmentName,
              items: [
                {key: "APPLY_RECORD_SELECT" + "|" + item.departmentId, label: `申请记录(${item.departmentName})`,},
                {key: "ARRIVE_RECORD_SELECT" + "|" + item.departmentId, label: `到访记录(${item.departmentName})`,}
              ]
            })
          }
        })
        this.setupPermission(account)
      }
    }).catch((error) => {
      console.log("error =>", error)
    })

  },

  data() {
    return {
      drawerRules: {
        telephone: [
          {required: true, message: '请输入手机号码', trigger: 'change'},
          // { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        telephoneRep: [
          {required: true, message: '请再次输入手机号码', trigger: 'change'},
          // { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        oldPassword: [
          {required: true, message: '请输入旧密码', trigger: 'change'},
          // { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        newPassword: [
          {required: true, message: '请输入新密码', trigger: 'change'},
          // { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        newPasswordRep: [
          {required: true, message: '请再次输入新密码', trigger: 'change'},
          // { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ]
      },

      drawer: false,

      type: '', // tel or password
      drawerForm: {},
      drawerLabel: [],

      form: {},

      formLabel: [
        {prop: 'name', label: '账号名称'},
        {prop: 'telephone', label: '手机号码'},
        {prop: 'createTime', label: '创建时间'},
        {prop: 'updateTime', label: '上次更新'},
        {prop: 'roleName', label: '角色类型'},
        {prop: 'areaName', label: '账号区域'},
      ],
      permissionTree: [
        {
          "key": "VISITOR_FORM",
          "type": "",
          "label": "访客表单",
          "items": [{"key": "VISITOR_FORM_SELECT", "label": "查看访客表单"}, {
            "key": "VISITOR_FORM_MODIFY",
            "label": "修改访客表单"
          }]
        }, {
          "key": "VISITOR_FLOW",
          "type": "",
          "label": "访客流程",
          "items": [{"key": "VISITOR_FLOW_SELECT", "label": "查看访客流程"}, {
            "key": "VISITOR_FLOW_MODIFY",
            "label": "修改访客流程"
          }]
        }, {
          "key": "VISITOR_SYSTEM_SETTING",
          "type": "",
          "label": "系统设置",
          "items": [{"key": "SYSTEM_SETTING_SELECT", "label": "查看系统设置"}, {
            "key": "SYSTEM_SETTING_MODIFY",
            "label": "修改系统设置"
          }]
        }, {
          "key": "GUARD_HELPER",
          "type": "",
          "label": "门岗助手",
          "items": [{"key": "GUARD_HELPER_SELECT", "label": "查看门岗助手"}, {
            "key": "GUARD_HELPER_MODIFY",
            "label": "操作门岗助手"
          }]
        },  {
          "key": "HARDWARE_MANAGE",
          "type": "",
          "label": "硬件管理",
          "items": [
            {"key": "AREA_MANAGE_SELECT", "label": "查看区域信息"},
            {"key": "AREA_MANAGE_MODIFY", "label": "修改区域信息"},
            {"key": "DEVICE_MANAGE_SELECT", "label": "查看访客设备"},
            {"key": "DEVICE_MANAGE_MODIFY", "label": "修改访客设备"}]
        }, {
          "key": "EMPLOYEE_MANAGE",
          "type": "",
          "label": "员工管理",
          "items": [{"key": "EMPLOYEE_MANAGE_SELECT", "label": "查看员工信息"}, {
            "key": "EMPLOYEE_MANAGE_MODIFY",
            "label": "修好员工信息"
          }]
        }, {
          "key": "VISITOR_MANAGE",
          "type": "",
          "label": "访客管理",
          "items": [{"key": "VISITOR_MANAGE_SELECT", "label": "查看访客信息"}, {
            "key": "VISITOR_MANAGE_MODIFY",
            "label": "修改访客信息"
          }]
        }, {
          "key": "LOG_MANAGE",
          "type": "",
          "label": "日志查看",
          "items": [{"key": "LOG_MANAGE_SELECT", "label": "日志查看"}]
        }, {
          "key": "HOME_SCREEN",
          "type": "",
          "label": "首页大屏",
          "items": [{"key": "HOME_SCREEN_SELECT", "label": "首页大屏"}]
        }
        ],

      accountData: {},

      areaTree: [],
      areaMap: {},
    }
  },

  computed: {
    ...mapState(['loginInfo', "employeeLoginInfo"])
  },

  methods: {
    ...mapMutations(['setLoginData', "setEmployeeLoginData"]),

    setupPermission(account) {
      if (account.roleType === "COMMON") {
        this.form.commonRoleName = this.$store.state.roleData.name
        this.formLabel.push({prop: 'commonRoleName', label: '角色名称'})
        let permissions = []
        let selectPermission = []
        this.$store.state.roleData.permissions.forEach((leve1) => {
          leve1.items.forEach((leve2) => {
            if (leve2.state === "VALID") {
              let key = leve2.type
              if (leve1.departmentId) {
                key = leve2.type + "|" + leve1.departmentId
              }
              let label = this.getPermissionLabelByKey(key)
              permissions.push({key: key, label: label})
              selectPermission.push(key)
            }
          })
        })
        this.form.permissions = permissions
        this.form.selectPermission = selectPermission

      }
    },

    getPermissionLabelByKey(key) {
      let label = ""
      this.permissionTree.forEach((item) => {
        if (item.key === key) {
          label = item.label
        } else {
          item.items.forEach((item2) => {
            if (item2.key === key) {
              label = item2.label
            }
          })
        }
      })

      return label
    },
    modifyPassword() {
      this.drawerLabel = []

      this.drawerLabel.push({prop: 'oldPassword', label: '当前密码'})
      this.drawerLabel.push({prop: 'newPassword', label: '设置新密码'})
      this.drawerLabel.push({prop: 'newPasswordRep', label: '验证新密码'})

      this.type = "password"
      this.drawer = true
    },

    modifyTel() {
      this.drawerLabel = []

      this.drawerLabel.push({prop: 'telephone', label: '新手机号码'})
      this.drawerLabel.push({prop: 'telephoneRep', label: '验证手机号码'})

      this.type = "tel"
      this.drawer = true
    },

    onSubmit() {
      // console.log("loginInfo =>", this.loginInfo)
      // console.log("drawerForm =>", this.drawerForm)

      this.$refs["drawerForm"].validate((valid) => {
        if (valid) {
          if (this.type === "tel") {
            if (this.drawerForm.telephone !== this.drawerForm.telephoneRep) {
              this.$message.error("两次输入手机号码不一致")
              return
            }

            this.$message.success("修改成功")
            this.onSubmitTel()
          } else if (this.type === "password") {
            if (this.drawerForm.newPassword !== this.drawerForm.newPasswordRep) {
              this.$message.error("两次输入密码不一致")
              return
            }

            // 密码长度需要设置为8位-16位
            if (this.drawerForm.newPassword.length < 8 || this.drawerForm.newPassword.length > 16) {
              this.$message.error("密码长度需要设置为8位-16位")
              return
            }

            // 密码需要包含大写字母，小写字母，数字，特殊符号中的三种
            let passCount = 0;
            let hasUpper = false;
            let hasLower = false;
            let hasNumber = false;
            let hasSpecial = false;
            const specialChars = "!@#$%^&*()_+{}|:<>?~`-=[];',./";
            for (let i = 0; i < this.drawerForm.newPassword.length; i++) {
              let c = this.drawerForm.newPassword.charAt(i);
              if (c >= 'A' && c <= 'Z') {
                hasUpper = true;
              } else if (c >= 'a' && c <= 'z') {
                hasLower = true;
              } else if (c >= '0' && c <= '9') {
                hasNumber = true;
              } else if (specialChars.indexOf(c) >= 0) {
                hasSpecial = true;
              }
            }
            if (hasUpper) {
              passCount++;
            }
            if (hasLower) {
              passCount++;
            }
            if (hasNumber) {
              passCount++;
            }
            if (hasSpecial) {
              passCount++;
            }
            if (passCount < 3) {
              this.$message.error("密码需要包含大写字母，小写字母，数字，特殊符号中的三种")
              return
            }

            // 旧密码由后端按当前 token 实查校验：cookie 缓存明文在 SSO 免登会话缺失、改密后也不刷新
            checkPassword(this.drawerForm.oldPassword).then(({data}) => {
              if (data.code !== 200) {
                this.$message.error("旧密码输入错误")
                return
              }
              this.$message.success("修改成功")
              this.onSubmitPassword()
            }).catch(err => {
              console.log(" checkPassword =>", err)
              this.showNetErrMsg()
            })
          }
        } else {
          console.log('validate error, error submit!!');
          return false;
        }
      });
    },

    onSubmitTel() {
      if (this.$store.state.accountType === "manage") {
        let account = {
          id: this.loginInfo.id,
          telephone: this.drawerForm.telephone
        }

        accountUpdate(account).then(({data}) => {
          if (data.code === 200) {
            this.setLoginData(data.data)
            this.form.telephone = data.data.telephone

            this.drawer = false
          } else {
            this.showServerErrMsg(data.code)
          }
        }).catch((error) => {
          console.log(this.NET_ERR_NETWORK)
        })
      } else {
        let account = {
          id: this.employeeLoginInfo.id,
          tel: this.drawerForm.telephone
        }

        updateEmployee(account).then(({data}) => {
          if (data.code === 200) {
            this.setEmployeeLoginData(data.data)
            this.form.telephone = data.data.tel

            this.drawer = false
          } else {
            this.showServerErrMsg(data.code)
          }
        }).catch((error) => {
          console.log(this.NET_ERR_NETWORK)
        })
      }

    },

    onSubmitPassword() {
      if (this.$store.state.accountType === "manage") {
        let account = {
          id: this.loginInfo.id,
          password: this.drawerForm.newPassword
        }

        accountUpdate(account).then(({data}) => {
          if (data.code === 200) {
            this.setLoginData(data.data)
            this.form.password = data.data.password

            this.drawer = false
          } else {
            this.showServerErrMsg(data.code)
          }
        }).catch((error) => {
          console.log(this.NET_ERR_NETWORK)
        })
      } else {
        let account = {
          id: this.employeeLoginInfo.id,
          loginPassword: this.drawerForm.newPassword
        }

        updateEmployee(account).then(({data}) => {
          if (data.code === 200) {
            this.setEmployeeLoginData(data.data)
            this.form.password = data.data.password

            this.drawer = false
          } else {
            this.showServerErrMsg(data.code)
          }
        }).catch((error) => {
          console.log(this.NET_ERR_NETWORK)
        })
      }
    },

    onCancel() {
      this.drawer = false
    },

    getShowTime(timeStr) {
      let time = new Date(timeStr)

      return time.getFullYear() + '-' + time.getMonth() + "-" + time.getDay()
          + ' ' + time.getHours() + ':' + time.getMinutes() + ':' + time.getSeconds()
    }
  }
}

</script>

<style lang="less" scoped>

.edit-form {
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100%;

  .header-content {
    margin-bottom: 20px;
  }

  .main-content {
    flex: 1 0 auto;

    .el-form-item {
      display: flex;
      justify-content: flex-start;

      /deep/ .el-form-item__label {
        width: 130px;
      }

      .el-input {
        width: calc(20vw);
      }
    }
  }

  .footer-content {
    text-align: center;
    flex: 0 0 auto;
  }
}

.account-info-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.manage {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 50vw;

  .manage-header {
    margin-bottom: 20px;
  }

  .manage-form {
    width: 50vw;
    // border: 1px solid #eaeaea;
    // box-shadow: 0 0 25px #cac5c6;
    // margin: 10px auto;


    .el-form-item {
      display: flex;
      justify-content: flex-start;

      /deep/ .el-form-item__label {
        width: 100px;
      }

      /deep/ .el-input {
        width: calc(50vw - 200px);
      }
    }
  }
}

</style>
